import styled from "styled-components";

export const DamRow = styled.div`
  ${(props) => `
    background-color: ${props.theme.colors.primaryBlue};
    font-family: ${props.theme.fontFamilies.primaryFont};
  `}
  color: ${(props) => props.theme.colors.white};
  align-items: center;
  border-radius: 10px;
  box-shadow: 0px 10px 100px rgba(231, 231, 234, 0.74);
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  font-size: 1.6rem;
  font-weight: 500;
  padding: 1.5rem;

  span {
    color: rgba(255, 255, 255, 0.5);
  }

  .dam-id--container {
    margin-bottom: 0.5rem;
  }

  .consignee-name {
    font-size: 1.4rem;
    font-weight: 600;
  }

  & > div {
    align-items: center;
    display: flex;
    flex-direction: column;
  }

  .main-info {
    align-items: flex-start;
  }
`;

interface IStatusDiv {
  status?: string;
  clickable?: any;
}
export const StatusDiv = styled.div<IStatusDiv>`
  ${(props) => {
    let color, backgroundColor;
    if (props.status === "problem") {
      color = props.theme.colors.supportRed;
      backgroundColor =
        props.theme.colors.supportRed + props.theme.transparencies.p10;
    } else {
      color = props.theme.colors.betterGreen;
      backgroundColor =
        props.theme.colors.betterGreen + props.theme.transparencies.p10;
    }
    return `
    span {
      background-color: ${backgroundColor};
      color: ${color};
      font-size: 1.1rem;
      font-weight: 600;
      padding: 0.6rem;
    }
    cursor: ${props.clickable ? "pointer" : "default"}
`;
  }}
`;

export const DamContainer = styled.div`
  margin-bottom: 1rem;
`;
